import BaseNode from '@appblocks/codegeneration/Nodes/BaseNode';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    Setting,
    TibboDataType,
} from '@appblocks/codegeneration/types';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import NodePort from '@appblocks/codegeneration/Nodes/NodePort';
import NodeParameter from '@appblocks/codegeneration/Nodes/NodeParameter';

export default class NodeGroupOutput extends BaseNode {
    constructor() {
        super();
        this.name = 'Group Output';
        this.id = 'node_group_output';
        this.linkedFeature = 'general';

        this.inputs = [
            {
                name: 'Group Output',
                portId: 'input',
                params: [],
            },
        ];
    }
}
